import { useState } from "react";
import ContactService from "../../services/ContactService";
import InputMask from "react-input-mask";
import { showToastError, showToastSuccess } from "utils/toasts";

const Contact = ({
  post_type_id,
  post_id,
  classe = "flex flex-col w-full sm:w-[28rem] h-full group rounded-3xl overflow-hidden bg-primary-50 dark:bg-gray-600 shadow-sm items-center p-2 m-10",
}: any) => {
  const [comentario, setComentario] = useState("");
  const [phone, setPhone] = useState("");

  const storedUserData = localStorage.getItem("userData");
  const initialUserData = storedUserData ? JSON.parse(storedUserData) : {};
  const [dadosUser, setDadosUser] = useState(initialUserData);
  const [loading, setLoading] = useState(false);

  const enviarMensagem = async () => {
    if (comentario === "") {
      showToastError("Comentário não pode ser vazio");
      return;
    }

    if (!dadosUser.id) {
      alert("Você precisa estar logado para enviar uma mensagem.");
      return;
    }

    let dadosComment: any = {
      user_id: dadosUser.id,
      post_id: post_id,
      post_type_id: post_type_id,
      comment: comentario,
      email: dadosUser.email,
      phone: phone,
    };

    let url: any = "/posts/" + post_id + "/contact";

    setLoading(true);
    await ContactService.postMensagem(dadosComment, url)
      .then((response: any) => {
        showToastSuccess("Mensagem enviada com sucesso!");
        setLoading(false);
        setComentario("");
        setPhone("");
      })
      .catch((error: any) => {
        setLoading(false);
        console.error(error);
      });
  };

  return (
    <div className={classe}>
      <span className="mt-1 w-full font-medium mb-2">Enviar Mensagem</span>
      <textarea
        placeholder=""
        className="text-black rounded-3xl mb-8 h-52 shadow-md border-transparent dark:bg-gray-300 w-full"
        onChange={(e) => setComentario(e.target.value)}
        value={comentario}
      />
      <span className="mt-1 w-full font-medium mb-2">Telefone / WhatsApp</span>
      <div className="flex flex-row items-center gap-x-2 pl-4 rounded-3xl mb-8 h-12 shadow-md border-transparent bg-white dark:bg-gray-300 w-full">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTly-8WpV4PplQsPe63olSOTap2JKLCpAZuPg&usqp=CAU"
          className="h-full py-3 mix-blend-multiply"
        />
        <InputMask
          // mask="(99) 99999-9999"
          mask=""
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="text-black border-hidden border-0 bg-transparent dark:bg-gray-300 w-full h-full overflow-hidden resize-none rounded-r-full"
        ></InputMask>
      </div>
      <button
        onClick={() => enviarMensagem()}
        disabled={loading} // Desabilita o botão enquanto loading for true
        className={`w-fit rounded-full px-12 py-3 text-white ${
          loading
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-primary-900 hover:bg-primary-600"
        }`}
      >
        {loading ? "Enviando..." : "Enviar"}
      </button>
    </div>
  );
};

export default Contact;
